<template>
  <div class="MyTable">
    <div class="table fs18">
      <div class="title">
        <div class="item" v-for="t in titles" :style="{width: t.w}">{{t.text}}</div>
      </div>
      <div class="row" v-for="(info, index) in infos" :class="{'even': index % 2}" >
        <div class="item" v-for="(i, ind) in info" :style="{width: titles[ind].w}">{{i}}</div>
        <div class="item showDetail" @click="showDetail(index)">
          查看
        </div>
      </div>
    </div>
    <div class="detail" :class="{show: detailShow}">
      <div class="title fs20">
        {{infos[indexOfDetail][2]}}
      </div>
      <div class="line" v-for="d in details[indexOfDetail]">
        {{d}}
      </div>
      <div class="close" @click="close"></div>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'MyTable',
   props: ['titles', 'infos', 'details'],
   data () {
     return {
       indexOfDetail: 0,
       detailShow: false
     }
   }, methods: {
     showDetail(i) {
       this.indexOfDetail = i;
       this.detailShow = true;
     },
     close(){
       this.detailShow = false;
     }
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyTable{
   display: flex;
   align-items: center;
   justify-content: center;
   position: relative;
 }
 .table{
   /* width: 62.5vw; */
   border: 2px solid #3B4ADD;
 }
 .title{
   display: flex;
   background: linear-gradient(90deg, #3b4add, #5e29ed);
   color: white;
   height: 4.0625vw;
 }
 .row{
   display: flex;
   height:3.4375vw;
 }
 .item{
   display: flex;
   align-items: center;
   justify-content: center;
 }
 .showDetail{
   width: 6vw;
   color: #3b4add;
   cursor: pointer;
 }
 .detail {
   display: none;
   box-sizing: border-box;
   position: absolute;
   text-indent: 2em;
   width: 100%;
   height: 100%;
   padding-top: 5vw;
   padding-bottom: 5vw;
   padding-left: 30vw;
   padding-right: 30vw;
   background-color: rgba(255,255,255, 0.9);

 }
 .detail.show{
   display: block;
 }
 .line{
   background: white;
   line-height: 2vw;
 }
 .detail .title{
   color: black;
   background: white;
   font-weight: 600;
   text-align: center;
   display: block;
 }
 .close{
   background-image: url(~@/assets/image/aboutus/close.png);
   background-size: 2vw;
   width: 2vw;
   height: 2vw;
   position: absolute;
   right: 28vw;
   top: 2vw;
   cursor: pointer;
 }
 .even{
   background-color: #f7fbfe;
 }
</style>
